// eslint-disable-next-line
import { h, Component } from 'preact';
import ProductListItem from './components/ProductListItem';

import styles from './index.scss';

class ProductList extends Component {
    componentDidMount() {
        document.dispatchEvent(new CustomEvent('miniCartDisplay'));
    }

    render() {
        const {
            items,
            labels: { ecommerce_keyword_qty, unavailable_firstUppercase },
            numbersOfItemsObj,
        } = this.props;

        const visibleItems = items.slice(0, numbersOfItemsObj.visible);

        return (
            <ul className={styles.list} data-mini-cart-sales-insight={JSON.stringify(visibleItems)}>
                {visibleItems.map((element, index, array) => (
                    <ProductListItem
                        key={index}
                        item={element}
                        index={index}
                        items={array}
                        ecommerce_keyword_qty={ecommerce_keyword_qty}
                        unavailable_firstUppercase={unavailable_firstUppercase}
                        numbersOfItemsObj={numbersOfItemsObj}
                    />
                ))}
            </ul>
        );
    }
}

export default ProductList;
